// PoovizhiDoc.jsx
import React from 'react'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import poovizhidoc from './../../../../assets/images/Doctorsimages/poovizhidr.png' // Assuming similar naming convention
import favicon from "./../../../../assets/images/favicon.ico"
import AutoScrollImageRow from '../../AdvancedTreatmentsforHome/AutoScrollImageRow'
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

const PoovizhiDoc = () => {
  const navigate = useNavigate(); 
   useEffect(() => {
       document.title = "Dr. Poovizhi Devi | Expert Homeopathic Consultant & Functional Nutritionist";
       const metaDescription = document.querySelector("meta[name='description']");
       if (metaDescription) {
         metaDescription.setAttribute(
           "content",
           "Consult Dr. Poovizhi Devi (BHMS), a dedicated Homeopathic Consultant and Certified Functional Nutritionist. Specializing in holistic healing, individualized treatment, and root-cause recovery."
         );
       }
       const metaKeywords = document.querySelector("meta[name='keywords']");
     if (metaKeywords) {
  metaKeywords.setAttribute(
    "content",
    "best homeopathy doctor, homeopathic consultant, functional nutritionist, holistic healing specialist, natural treatment for chronic illness, individualized homeopathic care, homeopathy and nutrition expert, root cause healing doctor, female homeopathy doctor, consultant for lifestyle disorders"
  );
}

        // Set canonical link
        const existingCanonical = document.querySelector("link[rel='canonical']");
        if (existingCanonical) {
          existingCanonical.setAttribute("href", "https://www.h-cura.com/doctors/dr-poovizhi-devi-homeopathy-nutritionist");
        } else {
          const canonicalLink = document.createElement("link");
          canonicalLink.setAttribute("rel", "canonical");
          canonicalLink.setAttribute("href", "https://www.h-cura.com/doctors/dr-poovizhi-devi-homeopathy-nutritionist");
          document.head.appendChild(canonicalLink);
        }
        
     const existingFavicon = document.querySelector("link[rel='icon']");
     if (existingFavicon) {
       existingFavicon.setAttribute("href", favicon);
     } else {
       const faviconLink = document.createElement("link");
       faviconLink.setAttribute("rel", "icon");
       faviconLink.setAttribute("type", "image/x-icon");
       faviconLink.setAttribute("href", favicon);
       document.head.appendChild(faviconLink);
     }
     }, []);

const handleDownloadPdf = () => {
  const container = document.querySelector('.veenadoc');
  container.classList.add('veenadoc-pdf-mode');
  const originalStyles = new Map();
  const allElements = container.querySelectorAll('*');
  
  allElements.forEach(el => {
    originalStyles.set(el, {
      transition: el.style.transition,
      animation: el.style.animation,
      transform: el.style.transform,
      filter: el.style.filter
    });
    el.style.transition = 'none';
    el.style.animation = 'none';
    el.style.transform = 'none';
    el.style.filter = 'none';
  });

  const heroSection = container.querySelector('.veenadoc-hero-section');
  if (heroSection) {
    heroSection.style.minHeight = 'auto';
    heroSection.style.padding = '40px 0';
  }

  const images = container.querySelectorAll('img');
  images.forEach(img => {
    img.style.opacity = '1';
  });

  setTimeout(() => {
    html2canvas(container, {
      scale: 2,
      dpi: 300,
      useCORS: true,
      allowTaint: true,
      letterRendering: true,
      backgroundColor: '#ffffff',
      logging: false,
      windowWidth: container.scrollWidth,
      windowHeight: container.scrollHeight,
      scrollY: -window.scrollY,
      scrollX: -window.scrollX,
      imageTimeout: 0,
      removeContainer: false
    }).then(canvas => {
      container.classList.remove('veenadoc-pdf-mode');
      allElements.forEach(el => {
        const original = originalStyles.get(el);
        el.style.transition = original.transition;
        el.style.animation = original.animation;
        el.style.transform = original.transform;
        el.style.filter = original.filter;
      });

      if (heroSection) {
        heroSection.style.minHeight = '';
        heroSection.style.padding = '';
      }

      const imgData = canvas.toDataURL('image/jpeg', 0.95);
      const pdf = new jsPDF('p', 'mm', 'a4', true);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const canvasWidth = canvas.width;
      const canvasHeight = canvas.height;
      const marginLeft = 10;
      const marginRight = 10;
      const availableWidth = pdfWidth - marginLeft - marginRight;
      const scaleFactor = availableWidth / canvasWidth;
      const imgWidth = canvasWidth * scaleFactor;
      const imgHeight = canvasHeight * scaleFactor;
      const pages = Math.ceil(imgHeight / pdfHeight);

      for (let i = 0; i < pages; i++) {
        if (i > 0) pdf.addPage();
        pdf.addImage(imgData, 'JPEG', marginLeft, -i * pdfHeight, imgWidth, imgHeight, undefined, 'FAST');
      }
      pdf.save('Dr.Poovizhi_Devi_Profile.pdf');
    }).catch(error => {
      console.error('Error generating PDF:', error);
      container.classList.remove('veenadoc-pdf-mode');
    });
  }, 100);
};

  return (
    <>
      <div className="veenadoc">
        {/* Hero Section */}
        <div className="veenadoc-hero-section">
          <div className="veenadoc-hero-background">
            <div className="veenadoc-wave-pattern">
              <svg viewBox="0 0 1200 320" className="veenadoc-wave-svg" preserveAspectRatio="none">
                <path d="M0,96L48,112C96,128,192,160,288,186.7C384,213,480,235,576,213.3C672,192,768,128,864,128C960,128,1056,192,1152,208C1248,224,1344,192,1392,176L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z" fill="rgba(46, 125, 50, 0.1)"></path>
              </svg>
            </div>
            <div className="veenadoc-floating-shapes">
              <div className="veenadoc-shape veenadoc-shape-1"></div>
              <div className="veenadoc-shape veenadoc-shape-2"></div>
              <div className="veenadoc-shape veenadoc-shape-3"></div>
              <div className="veenadoc-shape veenadoc-shape-4"></div>
            </div>
          </div>

          <div className="veenadoc-container">
            <div className="veenadoc-hero-content">
              <div className="veenadoc-hero-left">
                <h1 className="veenadoc-hero-title">
                  <span className="veenadoc-title-highlight">Dr. Poovizhi Devi</span>
                  <span className="veenadoc-title-credentials">(BHMS)</span>
                  <span className="veenadoc-title-location">Homeopathic Consultant & Functional Nutritionist</span>
                </h1>

                <div className="veenadoc-hero-description">
                  <p>
                    A distinguished Homeopathic Consultant recognized for her integrated approach to health, blending 
                    traditional homeopathic principles with the modern science of <strong>Functional Nutrition</strong>. 
                    With a focus on sustainable wellness, she provides a comprehensive path to recovery addressing physical and nutritional health.
                  </p>
                </div>

                <div className="veenadoc-hero-actions">
                  <button className="veenadoc-btn-primary-gradient" onClick={() => navigate('/bookconsultation')}>
                    <span className="veenadoc-btn-icon">📞</span>
                    <span>Book Consultation</span>
                    <div className="veenadoc-btn-shine"></div>
                  </button>
                </div>
              </div>

              <div className="veenadoc-hero-right">
                <div className="veenadoc-doctor-showcase">
                  <div className="veenadoc-doctor-frame">
                    <div className="veenadoc-frame-glow"></div>
                    <div className="veenadoc-image-container">
                      <img src={poovizhidoc} alt="Dr. Poovizhi Devi – Homeopathic Consultant & Functional Nutritionist" className="veenadoc-doctor-image" title='Dr. Poovizhi Devi – Homeopathic Consultant & Functional Nutritionist' />
                      <div className="veenadoc-image-overlay"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Article Content */}
        <div className="veenadoc-article-section">
          <div className="veenadoc-container">
            <div className="veenadoc-article-layout">
              <div className="veenadoc-article-main">

                {/* Introduction */}
                <div className="veenadoc-article-block">
                  <h2>About Dr. Poovizhi Devi</h2>
                  <p>
                    Dr. Poovizhi Devi earned her degree from the esteemed Sivaraj Homeopathic Medical College & Research Institute, 
                    affiliated with The Tamil Nadu Dr. MGR Medical University, laying a rigorous academic foundation for her clinical practice.
                  </p>
                  <p>
                    She understands that internal chemistry and dietary habits play a pivotal role in how the body responds to treatment. 
                    By integrating functional nutrition with homeopathy, she offers a specialized form of care that optimizes the body’s innate ability to repair itself.
                  </p>
                </div>

                {/* Dual Expertise */}
                <div className="veenadoc-article-block">
                  <h2>A Unique Dual Expertise in Healing</h2>
                  <p>
                    What sets Dr. Poovizhi apart is her dual certification as a Functional Nutritionist. This combination is particularly 
                    effective for patients dealing with metabolic issues, digestive disorders, and chronic lifestyle-related conditions.
                  </p>
                  <p>
                    She bridges the gap between traditional medicine and modern wellness by focusing on root-cause analysis and 
                    nutritional integration, using food as medicine to support homeopathic remedies.
                  </p>
                </div>

                <div className="veenadoc-sidebar-card">
                  <h3>Quick Information</h3>
                  <div className="veenadoc-info-grid">
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Qualification:</span>
                      <span className="veenadoc-info-value">BHMS, Functional Nutritionist</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Experience:</span>
                      <span className="veenadoc-info-value">3+ Years</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Specialization:</span>
                      <span className="veenadoc-info-value">Homeopathy & Nutrition</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Focus:</span>
                      <span className="veenadoc-info-value">Holistic Healing</span>
                    </div>
                  </div>
                </div>

                {/* Clinical Experience */}
                <div className="veenadoc-article-block">
                  <h2>Proven Clinical Experience</h2>
                  <p>
                    With over 3+ years of dedicated clinical practice, including significant experience at the Prabhakaran Homoeo Clinic, 
                    Dr. Poovizhi has successfully managed a diverse range of acute and chronic cases.
                  </p>
                  <p>
                    Her expertise extends to treating hormonal imbalances, skin conditions, respiratory allergies, and stress-induced 
                    ailments. Her time in active clinical settings has refined her ability to prescribe precise homeopathic remedies.
                  </p>
                </div>

                {/* Nutrition Advantage */}
                <div className="veenadoc-article-block">
                  <h2>The Functional Nutrition Advantage</h2>
                  <p>
                    In today’s fast-paced world, many health issues are rooted in nutritional deficiencies and lifestyle imbalances. 
                    As a Certified Functional Nutritionist, Dr. Poovizhi guides her patients through customized dietary interventions.
                  </p>
                  <p>
                    This holistic synergy helps in managing weight, improving energy levels, and strengthening the immune system, 
                    providing a long-term wellness solution rather than a temporary fix.
                  </p>
                </div>

                {/* Search Queries */}
                <div className="veenadoc-article-block">
                  <h2>Specialized Patient Care</h2>
                  <p>
                    Patients seeking a "homeopathic consultant near me" find her methodology transformative because she focuses on:
                  </p>
                  <ul className="veenadoc-search-queries-list">
                    <li>Root-Cause Analysis of chronic illness</li>
                    <li>Individualized homeopathic care plans</li>
                    <li>Functional nutrition for metabolic health</li>
                    <li>Holistic wellness and lifestyle correction</li>
                    <li>Empathetic and deep-listening consultations</li>
                  </ul>
                </div>

                {/* Conclusion */}
                <div className="veenadoc-article-block veenadoc-conclusion-block">
                  <h2>Choose Dr. Poovizhi Devi for Holistic Recovery</h2>
                  <p>
                    Choosing Dr. Poovizhi Devi means selecting a doctor committed to your complete health. She provides the assurance 
                    of safe treatments, the expertise of nutritional science, and the compassion of a holistic healer.
                  </p>
                  <p className="veenadoc-mission-statement">
                    <strong>Her mission:</strong> To empower patients with the knowledge and tools they need to achieve lasting health and renewed confidence.
                  </p>
                </div>
              </div>

              {/* Sidebar */}
              <div className="veenadoc-article-sidebar">
                {/* Philosophy of Care */}
                <div className="veenadoc-article-block veenadoc-philosophy-block">
                  <div className="veenadoc-philosophy-quote">
                    <div className="veenadoc-quote-icon">🌿</div>
                    <blockquote>
                      "Listening deeply, treating individually, and healing holistically"
                    </blockquote>
                    <p className="veenadoc-quote-attribution">— Dr. Poovizhi Devi's Philosophy</p>
                  </div>
                  <p>
                    She believes that true healing goes beyond temporary relief and requires addressing the root cause. 
                    This approach ensures that the treatment plan is as unique as the individual biological blueprint.
                  </p>
                </div>

                {/* Practice Locations */}
                <div className="veenadoc-sidebar-card">
                  <h3>Practice Focus</h3>
                  <div className="veenadoc-location-item">
                    <div className="veenadoc-location-icon">📍</div>
                    <div className="veenadoc-location-details">
                      <h4>Homeopathic Consultation</h4>
                      <p>Individualized medicine</p>
                    </div>
                  </div>
                  <div className="veenadoc-location-item">
                    <div className="veenadoc-location-icon">🥗</div>
                    <div className="veenadoc-location-details">
                      <h4>Functional Nutrition</h4>
                      <p>Dietary root-cause healing</p>
                    </div>
                  </div>
                </div>

                {/* Contact CTA */}
                <div className="veenadoc-sidebar-card veenadoc-cta-card">
                  <h3>Start Your Healing Journey</h3>
                  <p>Experience integrated healthcare with Dr. Poovizhi's personalized nutrition and homeopathy.</p>
                 <button className="veenadoc-sidebar-btn-primary" onClick={() => window.location.href = 'tel:+919964688333'}>
                  <span>📞</span>
                  <span>Schedule Appointment</span>
                </button>
                <button className="veenadoc-sidebar-btn-secondary" onClick={() => window.location.href = 'tel:+919964688333'}>
                  <span>💬</span>
                  <span>Get Free Assessment</span>
                </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <AutoScrollImageRow/>

       <div className="bangloregfcblog-download-section">
            <button className="bangloregfcblog-download-button" onClick={handleDownloadPdf}>
              Download This Doctor profile as PDF
            </button>
          </div>
    </>
  )
}

export default PoovizhiDoc;
